'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistorySlider = void 0;
const swiper_1 = require("swiper");
const modules_1 = require("swiper/modules");
class HistorySlider {
    constructor() {
        const slider = document.querySelector('.bulletHistorySlider');
        if (!slider)
            return;
        const swiperNextButton = document.querySelector('.swiper-button-next');
        const swiperPrevButton = document.querySelector('.swiper-button-prev');
        const historySwiper = new swiper_1.default(slider, {
            modules: [modules_1.Navigation],
            slidesPerView: "auto",
            // 前後の矢印
            navigation: {
                nextEl: swiperNextButton,
                prevEl: swiperPrevButton,
            },
        });
    }
}
exports.HistorySlider = HistorySlider;
exports.default = HistorySlider;
